export const clientId =
    "738587989523-jbn1lg4a1m3s7hfncr7fg0vg5q7mn2bg.apps.googleusercontent.com";
export const url = "https://noni.ypbpi.or.id/";
